var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504.19 705.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Monaco, Monaco;\n        font-size: 9.17px;\n        isolation: isolate;\n        letter-spacing: -.02em;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #435d79;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 492.57,
    y: 50.74,
    width: 1.07,
    height: 653.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 489.62,
    y: 703.96,
    width: 6.95,
    height: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.29,454.26H69.23V54.46h231.06v399.8h0ZM70.55,452.95h228.43V55.78H70.55v397.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.01,59.37h-1.32v-7.85H66.77v7.85h-1.32v-9.17h239.55v9.17h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.15,703.66l-19.39-2.88.1-.65,38.4-258.91,19.39,2.87-.1.65-38.4,258.91h0ZM30.26,699.67l16.78,2.49,38.11-256.96-16.78-2.49-38.11,256.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.45,703.66l-.09-.65-38.4-258.91,19.39-2.87.09.65,38.4,258.91-19.39,2.87h0ZM284.44,445.2l38.11,256.96,16.78-2.49-38.11-256.96-16.78,2.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.58,684.78l19.79-15.16,9.96,13.58-26.28,20.52-313.35-.49-25.89-20.03,9.96-13.57,19.62,15.02.17.13h306.02ZM337.13,683.47H32.01l-20.5-15.71-11.51,15.69,27.25,21.09,314.02.49h.23l27.64-21.58-11.51-15.69-20.51,15.7h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.99,464.55h-30.45v-11.6h30.45v11.6ZM169.86,463.23h27.82v-8.97h-27.82v8.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.9,460.4h-15.84l-3.03-6.52,1.19-.55,2.68,5.76h14.15l2.68-5.76,1.19.55-3.03,6.52h.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102.78,
    y: 453.6,
    width: 4,
    height: 19.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.61,
    y: 453.6,
    width: 4,
    height: 19.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.79,
    y: 472.81,
    width: 195.96,
    height: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.92,453.61v28.57c0,2.57,1.43,2,4.57,2s33.28.08,41.62.28c11.75.28,17.26,12,17.26,18,0,2.58,1.01,2.85,3,2.85h5.71v-5.43h-4s-3.05-19.06-21.9-20.13c-9.07-.51-16.26-.3-25.4-.3h-14.85c-.86,0-1.43-1.57-1.43-3.57v-22.28h-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.21,469.54h-7.46v-6.31h7.46v6.31h0ZM181.07,468.23h4.83v-3.68h-4.83v3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.78,473.97h-10.6v-4.17h10.6v4.17ZM179.5,472.66h7.97v-1.54h-7.97v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.78,473.97h-4.17v-4.17h4.17v4.17ZM172.93,472.66h1.54v-1.54h-1.54v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.92,473.97h-4.18v-4.17h4.17v4.17h0ZM193.06,472.66h1.54v-1.54h-1.54v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.49,511.11h-41.02v-38.45h41.02v38.45ZM164.79,509.8h38.39v-35.82h-38.39v35.82h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 170.64,
    y: 473.31,
    width: 26.58,
    height: 29.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 193.77,
    y: 450.99,
    width: 7.89,
    height: 1.32,
    transform: "translate(-201.01 161.66) rotate(-30.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.58,442.5l-.66-1.13,13.1-7.67.66,1.13-13.1,7.67ZM240.77,427.16l-.66-1.13,13.1-7.67.66,1.13-13.1,7.67ZM266.97,411.81l-.66-1.13,13.1-7.67.66,1.13-13.1,7.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 292.27,
    y: 393.28,
    width: 7.89,
    height: 1.32,
    transform: "translate(-158.39 203.5) rotate(-30.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.63,
    y: 389.95,
    width: 1.32,
    height: 7.9,
    transform: "translate(-302.72 255.55) rotate(-59.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.62,442.47l-12.88-7.66.67-1.13,12.88,7.66-.67,1.13ZM127.86,427.15l-12.88-7.66.67-1.13,12.88,7.66-.67,1.13ZM102.1,411.83l-12.88-7.66.67-1.13,12.88,7.66-.67,1.13h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 169.57,
    y: 447.66,
    width: 1.32,
    height: 7.89,
    transform: "translate(-304.92 367) rotate(-59.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.05,
    y: 75.15,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.11,356.97h-1.07v-10.63h1.07v10.63ZM93.11,335.7h-1.07v-10.63h1.07v10.63ZM93.11,314.44h-1.07v-10.63h1.07v10.63ZM93.11,293.17h-1.07v-10.63h1.07v10.63ZM93.11,271.9h-1.07v-10.63h1.07v10.63ZM93.11,250.63h-1.07v-10.63h1.07v10.63ZM93.11,229.36h-1.07v-10.63h1.07v10.63ZM93.11,208.1h-1.07v-10.63h1.07v10.63ZM93.11,186.83h-1.07v-10.63h1.07v10.63h0ZM93.11,165.56h-1.07v-10.63h1.07v10.63ZM93.11,144.29h-1.07v-10.63h1.07v10.63h0ZM93.11,123.03h-1.07v-10.63h1.07v10.63ZM93.11,101.76h-1.07v-10.63h1.07v10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.89,376.16l-4.85-2.91v-5.65h1.07v5.05l4.33,2.59-.55.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.53,407.11l-8.6-5.16.55-.92,8.6,5.16-.55.92ZM131.32,396.79l-8.6-5.16.55-.92,8.6,5.16-.55.92h0ZM114.1,386.48l-8.6-5.16.55-.92,8.6,5.16-.55.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 159.17,
    y: 410.47,
    width: 1.07,
    height: 5.35,
    transform: "translate(-276.79 337.86) rotate(-59.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.48,415.44l5.16-1.1-1.47-5.07,1.03-.3,1.79,6.17-6.29,1.33-.23-1.04h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 269.02,
    y: 75.15,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.09,362.97h-1.07v-10.87h1.07v10.87ZM270.09,341.24h-1.07v-10.87h1.07v10.87ZM270.09,319.51h-1.07v-10.87h1.07v10.87ZM270.09,297.78h-1.07v-10.87h1.07v10.87ZM270.09,276.05h-1.07v-10.87h1.07v10.87ZM270.09,254.32h-1.07v-10.87h1.07v10.87ZM270.09,232.59h-1.07v-10.87h1.07v10.87ZM270.09,210.86h-1.07v-10.87h1.07v10.87ZM270.09,189.13h-1.07v-10.87h1.07v10.87ZM270.09,167.4h-1.07v-10.87h1.07v10.87ZM270.09,145.67h-1.07v-10.87h1.07v10.87ZM270.09,123.94h-1.07v-10.87h1.07v10.87ZM270.09,102.21h-1.07v-10.87h1.07v10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.19,382.34l-.54-.93,4.36-2.53v-5.04h1.07v5.66l-4.89,2.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.67,410.44l-.53-.93,8.09-4.69.54.93-8.09,4.69h0ZM232.85,401.07l-.54-.93,8.09-4.69.54.93-8.09,4.69ZM249.02,391.7l-.54-.93,8.09-4.69.54.93-8.09,4.69h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 203.34,
    y: 415.47,
    width: 5.35,
    height: 1.07,
    transform: "translate(-180.98 159.62) rotate(-30.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.56,411.78l1.02.31-1.54,5.05,5.14,1.17-.24,1.04-6.27-1.43,1.88-6.14h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.93,
    y: 75.15,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.99,250.48h-1.07v-10.62h1.07v10.62ZM225.99,229.23h-1.07v-10.62h1.07v10.62ZM225.99,207.98h-1.07v-10.62h1.07v10.62ZM225.99,186.73h-1.07v-10.62h1.07v10.62ZM225.99,165.49h-1.07v-10.62h1.07v10.62ZM225.99,144.24h-1.07v-10.62h1.07v10.62ZM225.99,122.99h-1.07v-10.62h1.07v10.62ZM225.99,101.74h-1.07v-10.62h1.07v10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.99,355.81h-1.07v-10.7h1.07v10.7ZM225.99,334.41h-1.07v-10.7h1.07v10.7ZM225.99,313.01h-1.07v-10.7h1.07v10.7ZM225.99,291.61h-1.07v-10.7h1.07v10.7ZM225.99,270.22h-1.07v-10.92h1.07v10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.84,352.26l-.78-.73-3.59,3.86-3.59-3.86-.78.73,4.38,4.71,4.38-4.71h-.02Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "303.94 12.5 303.94 15.45 66.53 15.45 66.53 12.5 65.46 12.5 65.46 19.46 66.53 19.46 66.53 16.52 303.94 16.52 303.94 19.46 305.01 19.46 305.01 12.5 303.94 12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 137.6,
    y: 75.67,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.6,240.37h1.07v10.62h-1.07v-10.62ZM137.6,219.12h1.07v10.62h-1.07v-10.62ZM137.6,197.88h1.07v10.62h-1.07v-10.62ZM137.6,176.63h1.07v10.62h-1.07v-10.62ZM137.6,155.38h1.07v10.62h-1.07v-10.62ZM137.6,134.13h1.07v10.62h-1.07v-10.62ZM137.6,112.88h1.07v10.62h-1.07v-10.62ZM137.6,91.64h1.07v10.62h-1.07v-10.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.6,345.63h1.07v10.7h-1.07v-10.7ZM137.6,324.23h1.07v10.7h-1.07v-10.7ZM137.6,302.83h1.07v10.7h-1.07v-10.7ZM137.6,281.43h1.07v10.7h-1.07v-10.7ZM137.6,260.5h1.07v10.23h-1.07v-10.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.13,357.49l4.38-4.71-.78-.73-3.59,3.86-3.59-3.86-.78.73,4.38,4.71h-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.05,
    y: 75.67,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.05,240.37h1.07v10.62h-1.07v-10.62ZM184.05,219.12h1.07v10.62h-1.07v-10.62ZM184.05,197.88h1.07v10.62h-1.07v-10.62ZM184.05,176.63h1.07v10.62h-1.07v-10.62ZM184.05,155.38h1.07v10.62h-1.07v-10.62ZM184.05,134.13h1.07v10.62h-1.07v-10.62ZM184.05,112.88h1.07v10.62h-1.07v-10.62ZM184.05,91.64h1.07v10.62h-1.07v-10.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.05,345.63h1.07v10.7h-1.07v-10.7ZM184.05,324.23h1.07v10.7h-1.07v-10.7ZM184.05,302.83h1.07v10.7h-1.07v-10.7ZM184.05,281.43h1.07v10.7h-1.07v-10.7ZM184.05,260.5h1.07v10.23h-1.07v-10.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.58,357.49l4.38-4.71-.78-.73-3.59,3.86-3.59-3.86-.78.73,4.38,4.71h-.02Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(488.05 43.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50\u2019")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(180.56 8.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "26\u2019"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/blueprint.cb98ef6f7c44e2a9e8101b3c7f13a9b0.svg";
export { ForwardRef as ReactComponent };